<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink">
<p class="center ">To my family family</p>
<p class="center spaceabove1">To the <em>Sports Illustrated</em> family</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?31706062